import styled from 'styled-components'

export const Wrapper = styled.div`
  > div:first-child {
    width: 50%;
  }
`
